import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const MultiSelectEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-multi-group-picker-edit-view" */ './ui/multi-group-picker'
			),
	),
	getPreloadProps: () => ({}),
});

export default MultiSelectEditViewEntryPoint;
